

cmsForm2022.prototype.dateFields = function(){
  var fields = this.form.querySelectorAll(".dateField");
  for(let f of fields){
    if(f.querySelector("input")){
      continue;
    }

    var format = f.getAttribute("data-format") || "YYYY-MM-DD";
    this.disabled = f.getAttribute("data-disable") == "true" ? true : false;
    var label = document.createElement("label");
    label.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Calendar</title><rect fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" x="48" y="80" width="416" height="384" rx="48"/><circle cx="296" cy="232" r="24"/><circle cx="376" cy="232" r="24"/><circle cx="296" cy="312" r="24"/><circle cx="376" cy="312" r="24"/><circle cx="136" cy="312" r="24"/><circle cx="216" cy="312" r="24"/><circle cx="136" cy="392" r="24"/><circle cx="216" cy="392" r="24"/><circle cx="296" cy="392" r="24"/><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" stroke-linecap="round" d="M128 48v32M384 48v32"/><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" d="M464 160H48"/></svg>';
    var span = document.createElement("span");

    span.innerHTML = f.getAttribute("data-label");
    span.innerHTML += " ("+moment.tz(this.config.timezone).zoneAbbr()+")";

    if(f.getAttribute("data-required")){
      span.innerHTML = span.innerHTML + " <div class='requiredLabel'>*</div>";
    }

    label.append(span);
    var input = document.createElement("input");
    input.setAttribute("type","hidden");

    input.classList.add("dateFieldInput");
    input.setAttribute("name",f.getAttribute("data-name"));
    if(f.getAttribute("data-required")){
      input.setAttribute("data-required","true");

    }
    //input.value = new Date().getTime();

    var dateValue = document.createElement("div");
    dateValue.classList.add("dateValue");
    dateValue.innerHTML = f.getAttribute("data-placeholder") || "Choose a Date";


    label.append(input);
    label.append(dateValue);
    f.append(label);



    label.classList.add("withLabel");

    this.datePickerField = f;
    if(f.getAttribute("data-value")){
      //input.setAttribute("value",f.getAttribute("data-value"));
      var dayDate = new Date();
      var value = f.getAttribute("data-value");
      this.dateFieldPickerUpdateValue(value);
    }
    //this.dateFieldPickerUpdateValue(new Date().getTime(),format);
    if(this.disabled){ 
      f.classList.add("disabled");
    }
    else{
      f.addEventListener("click",(e)=>{
        e.preventDefault();
        this.dateFieldPicker(e);
      });
    }
  }
};

cmsForm2022.prototype.dateFieldPicker = function(e){
  this.datePickerField = e.currentTarget;
  this.dateFieldPickerCreate();
};

cmsForm2022.prototype.dateFieldPickerCreate = function(){
  if(this.datePickerScreen) return;
  var dateObj = new Date();

  var dateValue = this.datePickerField.querySelector("input").value;
  if(dateValue && dateValue !== ""){
    var [valueMonth,valueDate,valueYear] = dateValue.split("-");
    dateObj = new Date(Date.UTC(parseInt(valueYear),parseInt(valueMonth-1),parseInt(valueDate)));


  }

  this.datePickerScreen = document.createElement("div");
  this.datePickerScreen.classList.add("datePicker");

  var holder = document.createElement("div");
  holder.classList.add("datePickerHolder");
  this.datePickerScreen.append(holder);



  var label = document.createElement("h3");
  label.innerText = this.datePickerField.getAttribute("data-label") || "";
  holder.append(label);

  this.datePickerPrevious = document.createElement("button");
  this.datePickerPrevious.classList.add("datePickerPrevious");
  this.datePickerPrevious.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Back</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/></svg>';
  holder.append(this.datePickerPrevious);

  this.datePickerPrevious.addEventListener("click",(e)=>{
    e.preventDefault();
    var month = parseInt(this.datePickerMonth.value);
    var year = parseInt(this.datePickerYear.value);
    month = month - 1;
    if(month < 0){
      year = year - 1;
      month = 11;
    }

    this.datePickerMonth.querySelector("option[value='"+month+"']").selected = "selected";
    this.datePickerYear.querySelector("option[value='"+year+"']").selected = "selected";
    this.dateFieldPickerCalendar();

  });


  this.datePickerNext = document.createElement("button");
  this.datePickerNext.classList.add("datePickerNext");
  this.datePickerNext.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>';
  holder.append(this.datePickerNext);

  this.datePickerNext.addEventListener("click",(e)=>{
    e.preventDefault();
    var month = parseInt(this.datePickerMonth.value);
    var year = parseInt(this.datePickerYear.value);
    month = month + 1;
    if(month > 11){
      year = year + 1;
      month = 0;
    }

    this.datePickerMonth.querySelector("option[value='"+month+"']").selected = "selected";
    this.datePickerYear.querySelector("option[value='"+year+"']").selected = "selected";
    this.dateFieldPickerCalendar();

  });
  


  this.datePickerMonth = document.createElement("select");
  this.datePickerMonth.classList.add("datePickerMonth");
  var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  months.forEach((m,index)=>{
    var o = document.createElement("option");
    o.value = index;
    o.innerText = m;
    if(dateObj.getUTCMonth() == index){
      o.selected = "selected";
    }
    this.datePickerMonth.append(o);
  });
  this.datePickerMonth.addEventListener("change",(e)=>{
    this.dateFieldPickerCalendar();
  });
  holder.append(this.datePickerMonth);

  this.datePickerMonth.setAttribute("id","datePickerMonthSelect");


  this.datePickerYear = document.createElement("select");
  this.datePickerYear.setAttribute("id","datePickerYearSelect");

  this.datePickerYear.classList.add("datePickerYear");
  var startYear = 1900;
  var yearLength = new Date().getUTCFullYear() - startYear;
  if(this.datePickerField.getAttribute("data-future")){
    startYear = new Date().getUTCFullYear();
    yearLength = 5;
    Array.from({length:yearLength},(v,k)=>k).forEach((index)=>{
      var o = document.createElement("option");
      o.value = startYear+index;
      o.innerText = startYear+index;
      if(startYear + index == dateObj.getUTCFullYear()){
        o.selected = "selected";
      }

      this.datePickerYear.append(o);
    });
  }
  else{
    Array.from({length:yearLength},(v,k)=>k+1).forEach((index)=>{
      var o = document.createElement("option");
      o.value = startYear+index;
      o.innerText = startYear+index;
      if(dateObj.getUTCFullYear() == (startYear+index)){
        o.selected = "selected";
      }
      this.datePickerYear.append(o);
    });
  }



  this.datePickerYear.addEventListener("change",(e)=>{
    this.dateFieldPickerCalendar();
  });
  holder.append(this.datePickerYear);

  var clearFix = document.createElement("div");
  clearFix.classList.add("clearfix");
  holder.append(clearFix);

  var calendarHolder = document.createElement("div");
  calendarHolder.classList.add("datePickerCalendarHolder");

  this.datePickerCalendar = document.createElement("div");
  this.datePickerCalendar.classList.add("datePickerCalendar");
  calendarHolder.append(this.datePickerCalendar);

  holder.append(calendarHolder);

  this.datePickerScreen.addEventListener("click",(e)=>{
    if(e.target !== e.currentTarget) return;
    this.datePickerScreen.remove();
    this.monthPopupSelect.remove();
    this.yearPopupSelect.remove();
    this.datePickerScreen = false;
  })

  this.form.append(this.datePickerScreen);

  this.monthPopupSelect = new popupSelect("datePickerMonthSelect",{
    showClass:"show",
    title:"Select a Month:",
    onChange:()=>{
      this.dateFieldPickerCalendar();
    }
  });

  this.yearPopupSelect = new popupSelect("datePickerYearSelect",{
    showClass:"show",
    title:"Select a Year:",
    onChange:()=>{
      this.dateFieldPickerCalendar();
    }
  });



  this.dateFieldPickerCalendar();
};

cmsForm2022.prototype.dateFieldPickerUpdateValue = function(date){
  if(!this.datePickerField) return;

  var input = this.datePickerField.querySelector("input");
  input.value = date;

  var display = this.datePickerField.querySelector(".dateValue");

  this.datePickerField.setAttribute("data-value",date);

  display.innerHTML = this.dateFieldValue(date,this.datePickerField.getAttribute("data-format"));


  if(this.datePickerField.getAttribute("data-onChange")){
    eval(this.datePickerField.getAttribute("data-onChange"));

  }



};

cmsForm2022.prototype.dateFieldPickerCalendar = function(){
  this.monthPopupSelect.updateLabel();
  this.yearPopupSelect.updateLabel();
  var selectedValue = this.datePickerField.querySelector("input").value;
  var dateObj = new Date();
  var todayDateObj = new Date();
  var futureDates = this.datePickerField.getAttribute("data-future");
  if(selectedValue && selectedValue !== ""){
    var [valueMonth,valueDate,valueYear] = selectedValue.split("-");
    var selectedTimestamp = new Date(Date.UTC(parseInt(valueYear),parseInt(valueMonth-1),parseInt(valueDate))).getTime();
    dateObj.setTime(selectedTimestamp);

  }

  var month = this.datePickerMonth.value;
  var year = this.datePickerYear.value;



  if(!futureDates){
    if(month == todayDateObj.getUTCMonth()){
      this.datePickerNext.style.opacity = "0";
      this.datePickerNext.style.height = "0px";
    }
    else{
      this.datePickerNext.style.opacity = "1";
      this.datePickerNext.style.height = "40px";
    }
  }
  else{
    if(month == todayDateObj.getUTCMonth() && year == todayDateObj.getUTCFullYear()){
      this.datePickerPrevious.style.opacity = "0";
      this.datePickerPrevious.style.height = "0px";
    }
    else{
      this.datePickerPrevious.style.opacity = "1";
      this.datePickerPrevious.style.height = "40px";
    }
  }

  var selectedMonth = dateObj.getUTCMonth();
  var selectedYear = dateObj.getUTCFullYear();
  var selectedDate = dateObj.getUTCDate();





  var days = ["Sun","Mon","Tues","Weds","Thurs","Fri","Sat"];
  if(window.innerWidth < 700){
    days = ["Su","M","T","W","Th","F","S"];
  }
  this.datePickerCalendar.innerHTML = "";
  days.forEach(d=>{
    var cell = document.createElement("div");
    cell.innerHTML = d;
    cell.classList.add("datePickerDateHeader");
    this.datePickerCalendar.append(cell);
  });

  var firstDay = new Date(year,month).getDay();
  var lastDate = 32- new Date(year,month,32).getDate();
  var date = 1;
  for(let row = 0;row < 6;row++){

    for(let col = 0;col<7;col++){
      var cell = document.createElement("div");
      cell.classList.add("datePickerDate");
      if(row == 0 && col < firstDay){
        cell.innerHTML = "";

      }
      else if(date > lastDate){
        break;
      }
      else{
        month = parseInt(month);
        var dateTimestamp = new Date(Date.UTC(year,month,date)).getTime();
        cell.innerHTML = date;
        cell.classList.add("datePickerDateOption");
        cell.setAttribute("data-value",(month+1) + "-" + date + "-" +year);

        if(!futureDates && dateTimestamp > todayDateObj.getTime()){
          cell.classList.add("inactive");
        }
        else if(futureDates && (dateTimestamp+86400000) < (todayDateObj.getTime()+(this.config.timezoneOffset*60*60*1000))){
          cell.classList.add("inactive");
        }
        else{
          if(selectedDate && date == selectedDate && month == selectedMonth && year == selectedYear){
            cell.classList.add("selected");
          }
          cell.addEventListener("click",(e)=>{
            e.preventDefault();
            if(this.datePickerCalendar.querySelector(".selected")){
              this.datePickerCalendar.querySelector(".selected").classList.remove("selected");
            }
            e.target.classList.add("selected");
            this.dateFieldPickerUpdateValue(e.target.getAttribute("data-value"));

            //this.datePickerScreen.classList.add("hide");


            setTimeout(()=>{
              this.datePickerScreen.remove();
              this.monthPopupSelect.remove();
              this.yearPopupSelect.remove();
              this.datePickerScreen = false;
            },200);

          });
        }
        date++;
      }

      this.datePickerCalendar.append(cell);

    }

  }


};

cmsForm2022.prototype.dateFieldValue = function(date,format="YYYY-MM-DD"){
  var [valueMonth,valueDate,valueYear] = date.split("-");
  var timestamp = new Date(Date.UTC(parseInt(valueYear),parseInt(valueMonth-1),parseInt(valueDate))).getTime();
  return moment.utc(parseInt(timestamp)).format(format);
  //  return moment(new Date().setTime(timestamp)).format(format);

}
